import BusinessIcon from '@mui/icons-material/Business';

import CompanyList from './CompanyList';
import CompanyCreate from './CompanyCreate';
import CompanyShow from './CompanyShow';
import CompanyEdit from './CompanyEdit';

const companies = {
	list: CompanyList,
	create: CompanyCreate,
	show: CompanyShow,
	edit: CompanyEdit,
	icon: BusinessIcon
};

export default companies;
